<template>
	<v-form @submit="onSubmit">
		<functionality-form :doc="doc" />
		<pre>{{ loadedDoc }}</pre>
		<v-btn class="mt-5 amber black--text" @click="onSubmit">Submit</v-btn>
		<v-btn class="mt-5 amber black--text ml-2" @click="onClose">Close</v-btn>
	</v-form>
</template>

<script>
// @ is an alias to /src
import FunctionalityForm from './FunctionalityForm';
const fb = require('@/firebaseConfig.js');

export default {
	name: 'UserServiceEdit',
	components: {
		FunctionalityForm,
	},
	data() {
		return {
			doc: {},
			loadedDoc: false,
		};
	},
	props: {
		id: String,
		item: {
			type: Object,
			default: () => {},
		},
	},
	created() {
		this.init();
	},
	watch: {
		id(val) {
			if (val) this.init();
		},
	},
	methods: {
		init() {
			const ref = fb.functionalityCollection.doc(this.id);
			ref.get().then((doc) => {
				if (doc.exists) {
					this.loadedDoc = true;
					this.doc = doc.data();
				} else {
					this.loadedDoc = false;
					this.doc = this.item;
				}
			});
		},
		onSubmit(evt) {
			evt.preventDefault();
			if (this.loadedDoc) {
				this.updateDoc();
			} else {
				this.updateObj();
			}
		},
		updateDoc() {
			console.log('update doc');
			const updateRef = fb.functionalityCollection.doc(this.id);
			updateRef
				.set(this.doc)
				.then(() => {
					this.doc = {};
					this.$emit('complete', this.id);
					this.$emit('updateItem', this.doc);
					this.$emit('close');
				})
				.catch((error) => {
					alert('Error adding document: ', error);
				});
		},
		updateObj() {
			this.$emit('updateItem', this.doc);
			this.$emit('close');
		},
		onClose() {
			this.$emit('close');
		},
	},
};
</script>
